<template>
  <div>
    <b-row class='mb-3'>
      <b-col>
        <file-upload fieldName='image' label='Image' />  
      </b-col>
      <b-col>
        <file-upload fieldName='image_logo' label='Image logo' />  
      </b-col>
    </b-row>  
    <b-row class='mb-3'>
      <b-col>
        <file-upload fieldName='image_map' label='Image map' />  
      </b-col>
      <b-col>
        <file-upload fieldName='image_background' label='Image background' />  
      </b-col>
    </b-row>
    <b-row class='mb-3'>
      <b-col>
        <file-upload fieldName='image_nav' label='Image menu' />
      </b-col>
      <b-col />
    </b-row>
  </div>
</template>

<script>
  import FileUpload from '../FileUpload'
  
  export default {
    components: { FileUpload },
  }
</script>